import { useEffect, useRef } from "react";

interface AdPlacementProps {
  position: "top" | "sidebar" | "inline";
}

export const AdPlacement = ({ position }: AdPlacementProps) => {
  const getAdFormat = () => {
    switch (position) {
      case "top":
        return { format: "horizontal", style: { display: "block" } };
      case "sidebar":
        return { format: "vertical", style: { display: "block" } };
      case "inline":
        return { format: "rectangle", style: { display: "block" } };
      default:
        return { format: "auto", style: { display: "block" } };
    }
  };

  const adRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    // Wait until ad container has a non-zero width before pushing
    const el = adRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && el.offsetWidth > 0) {
            try {
              ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
            } catch (err) {
              // silently ignore ad errors
            }
            observer.disconnect();
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const adConfig = getAdFormat();

  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      style={adConfig.style}
      data-ad-client="ca-pub-5809797099622601"
      data-ad-format={adConfig.format}
      data-full-width-responsive="true"
    />
  );
};